import React from 'react'
import { Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(3)
    },
}));
/**
 * Blog page displays information the company's blog
 *
 * @component
 */
function BlogPage() {
    const classes = useStyles();
    // const history = useHistory();

    return (
        <Container component="main" maxWidth="md" className = {classes.root}>
            <h3>Blog</h3>
            <hr />
            <p>Coming soon...</p>
            <hr />
        </Container>
    )
}

export default BlogPage
